import script from "./article_xq.vue?vue&type=script&setup=true&lang=js"
export * from "./article_xq.vue?vue&type=script&setup=true&lang=js"

import "./article_xq.vue?vue&type=style&index=0&id=61cb4cff&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61cb4cff"]])

export default __exports__